import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const SplashMessage = _ref => {
  let {
      children
    } = _ref,
    viewProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({
    padding: "200",
    marginBlock: "100",
    marginInline: "auto"
  }, viewProps, {
    children: children
  }));
};